module.exports = __webpack_public_path__ + "img/avatar4.e284879d.png";